import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import PageMeta from '../../utils/PageMeta';
import useSlug from '../../utils/router/useSlug';
import HistoricalPost from '../history/HistoricalPost';
import HistorySidebar from '../history/HistorySidebar';
import styles from './CommentHistoryView.module.scss';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import QuillContext from '../../editor/QuillContext';
import { gql } from '../../graphql/generated/gql';
import { UIActions } from '../../ui/uiSlice';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
const POST_QUERY = gql(`
  query CommentHistoryViewPostQuery($id: ID!) {
    post(id: $id) {
      id
      title
      ...PostContent
    }
  }
`);

const CommentHistoryView = () => {
  const [postId] = useSlug('postSlug');
  const dispatch = useAppDispatch();

  const { data: { post } = {} } = useQuery(POST_QUERY, {
    variables: { id: postId },
  });

  useEffect(() => {
    dispatch(
      UIActions.openRightPanel(HistorySidebar, { postId, tab: 'comments' }),
    );
    return () => {
      dispatch(UIActions.closeRightPanel());
    };
  }, [dispatch, postId]);

  const defaultTitle = 'Comment History - Slab';
  const postTitle = post?.title;
  const documentTitle = postTitle
    ? `${postTitle} - ${defaultTitle}`
    : defaultTitle;

  return (
    <div
      className={classNames(styles.content, 'no-padding-x', 'no-padding-y')}
      id="content"
    >
      <PageMeta title={documentTitle} />
      {post && (
        <QuillContext>
          <div className={styles.editorWrapper}>
            <div className={styles.editor}>
              <HistoricalPost content={post.content} />
            </div>
          </div>
        </QuillContext>
      )}
    </div>
  );
};

export default CommentHistoryView;
